<template>
  <i class="toggle-selection-icon"
     :class="[{[`le-icon-${icon}`]: true, 'primary': usePrimary, 'active': isActive}]"
     v-html="require(`!html-loader!@assets/images/icons/${icon}.svg`)"
  >
  </i>
</template>

<script>

  export default {
    name: 'toggle-selection-icon',
    props: {
      isActive: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
      },
      usePrimary: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">

  .toggle-selection-icon /deep/ svg {

    [fill] {
      @include themify() {
        fill: getColor('unselected', 'amd')
      }
    }

    [stroke] {
      @include themify() {
        stroke: getColor('unselected', 'amd')
      }
    }
  }
  .toggle-selection-icon.primary /deep/ svg {

    [fill] {
      @include themify() {
        fill: getColor('primaryIcon', 'amd')
      }
    }

    [stroke] {
      @include themify() {
        stroke: getColor('primaryIcon', 'amd')
      }
    }
  }

  .toggle-selection-icon.active /deep/ svg {

    [fill] {
      @include themify() {
        fill: getColor('selected', 'amd')
      }
    }

    [stroke] {
      @include themify() {
        stroke: getColor('selected', 'amd')
      }
    }
  }

</style>

